import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import CourseraPlusHubApp from 'bundles/coursera-plus-landing-page/CourseraPlusHubApp';
import NotFound from 'bundles/phoenix/components/NotFound';

// Default Coursera Plus landing page (/courseraplus).
const LandingPage = loadOnRoute(
  () =>
    import(
      /* webpackChunkName: "coursera-plus-landing-page-redesign" */
      'bundles/coursera-plus-landing-page/components/LandingPageRedesign'
    )
);

// Coursera Plus promo pages (/courseraplus/special/:slug)
const CourseraPlusMarketingHome = loadOnRoute(
  () =>
    import(
      /* webpackChunkName: "coursera-plus-marketing-home-redesign" */
      'bundles/coursera-plus-landing-page/components/MarketingHomeRedesign'
    )
);

export default (
  <CourseraRoute
    component={CourseraPlusHubApp}
    path="/"
    handle={{
      tracking: { data: () => ({ page: { type: 'cplus_description' } }) },
    }}
  >
    <Route path="courseraplus">
      <IndexRoute getComponent={LandingPage} />
      <Route getComponent={LandingPage} path="subscribe/:id" />
      <Route getComponent={CourseraPlusMarketingHome} path="special/:slug" />
    </Route>

    <Route component={NotFound} path="*" />
  </CourseraRoute>
);
